import React, { useState, useEffect, useRef } from 'react';
import './TopBar.css';
import logo from '../../Images/logo.png';
import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import UserIcon from '@mui/icons-material/AccountBoxRounded';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from '../../Config/axiosInstance';

const TopBar = ({ toggleMenu }) => {
  const [department, setDepartment] = useState('');
  const [userName, setUserName] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);

  const notificationRef = useRef(null);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axiosInstance.get('user/department/');
        if (response.data?.department) {
          setDepartment(`${response.data.department} Department`);
        }
      } catch (error) {
        console.error('Eroare la obținerea departamentului:', error);
      }
    };

    const fetchUserName = async () => {
      try {
        const response = await axiosInstance.get('user/name/');
        if (response.data?.first_name && response.data?.last_name) {
          setUserName(`${response.data.first_name} ${response.data.last_name}`);
        }
      } catch (error) {
        console.error('Eroare la obținerea numelui utilizatorului:', error);
      }
    };

    const fetchNotifications = async () => {
      try {
        const response = await axiosInstance.get('/get_notifications/');
        setNotifications(response.data);
      } catch (error) {
        console.error('Eroare la obținerea notificărilor:', error);
      }
    };

    fetchDepartment();
    fetchUserName();
    fetchNotifications();
  }, []);

  // 🔽 CLICK OUTSIDE
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showNotifications]);

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  const deleteNotification = async (id) => {
    try {
      await axiosInstance.delete(`/delete_notification/${id}/`);
      const updatedNotifications = notifications.filter(notification => notification.id !== id);
      setNotifications(updatedNotifications);
    } catch (error) {
      console.error('Eroare la ștergerea notificării:', error);
    }
  };

  return (
    <div className="topbar">
      <div className="logo_section">
        <div className="logo">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="app-name">
          <h1>PMPC</h1>
          <h2>{department}</h2>
        </div>
      </div>

      <div className="user-section">
        <button className="menu-button" onClick={toggleMenu}>
          <MenuIcon fontSize="medium" style={{ marginRight: '6px' }} />
        </button>

        {/* 🔽 REF AICI */}
        <div className="notification-container" ref={notificationRef}>
          <button className="notification" onClick={toggleNotifications}>
            <NotificationsIcon fontSize="medium" style={{ marginRight: '4px' }} />
            {notifications.length > 0 && (
              <span className="notification-badge">{notifications.length}</span>
            )}
          </button>

          {showNotifications && (
            <div className="notification-dropdown">
              {notifications.length > 0 ? (
                notifications.map((notification) => (
                  <div key={notification.id} className="notification-item">
                    <p className="notification-text">
                      {notification.description}{' '}
                      {new Date(notification.date).toLocaleDateString()}
                    </p>
                    <CloseIcon
                      className="close-icon"
                      onClick={() => deleteNotification(notification.id)}
                    />
                  </div>
                ))
              ) : (
                <p className="no-notifications">You have no notifications!</p>
              )}
            </div>
          )}
        </div>

        <div className="user">
          <p>{userName}</p>
          <UserIcon
            className="User_icon"
            fontSize="medium"
            style={{ marginRight: '6px', marginLeft: '6px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default TopBar;